const stableObject = {};
const stableArray = [];

const getEventFolders = (folders, n) => {
  return (folders || stableArray)
    .filter((folder) => {
      const folderStatusIds = folder.statusIds || stableArray;
      const event = (n || stableObject).event_data || stableObject;
      const statusId = event.status_id;
      if (event.lead_id && folder.leads !== true) {
        return false;
      }
      if (!event.lead_id && folder.nonLeads !== true) {
        return false;
      }
      if (!!folder.formType && event.form_type !== folder.formType) {
        return false;
      }
      return !(!event.lead_id && !folderStatusIds.includes(statusId));
    })
    .map((n) => n.id);
};

export default getEventFolders;
